<template>
  <div>
    <!-- BANNER -->
    <div class="banner">
      <div class="banner-overlay box-overlay brand_inverse_bg rounded-top-10">
        <img v-lazy="localImg(banner)" class="img img-luminous">
      </div>
      <img v-lazy="localImg(display_img)" class="display-img">
    </div>

    <!-- WELCOME BLOCK -->
    <div class="welcome-block w-100 d-flex flex-column justify-content-start align-items-center">
      <div class="welcome-title font-weight-bold brand_navy">
        <template
          v-if="account_type === 'school' || account_type === 'teacher'"
        >Persoanlized Learning Resources</template>
        <template v-if="account_type === 'parent'">Tutor Interventions</template>
      </div>

      <div class="welcome-text color_grey_dark text-center">
        <template
          v-if="account_type === 'school' || account_type === 'teacher'"
        >Help each child uniquely with intelligent recommendations from a vast library of practice and video lesson resources</template>
        <template
          v-if="account_type === 'parent'"
        >Use regular or selective live tutor sessions to help your child improve much faster</template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogFive",

  props: ["banner", "display_img"],

  data() {
    return {
      account_type: this.$route.path.split("/")[1]
    };
  }
};
</script>

<style>
</style>
